// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"1323":"component---src-pages-mobile-money-pricing-js","33524":"app","39968":"component---src-pages-ekyc-pricing-js"}[chunkId] || chunkId) + "." + {"1323":"70cd36ab385445e6778f","33524":"f863559ddd572ab2dbd2","39968":"70cd36ab385445e6778f","65520":"10ce2bdb4c854c95a31d"}[chunkId] + ".css";
};